import {Vue, Component, Prop} from "vue-property-decorator";
import {Action} from "vuex-class";
import {Notification} from "~/modules/notifications/store";

@Component
export class NotificationComponent extends Vue {

  @Prop({type:Object, required:true}) notification:Notification;
  @Action closeNotification;

  mounted() {
    if( this.notification.duration !== -1 ){
      setTimeout(() => this.closeNotification(this.notification.id), this.notification.duration);
    }
  }

  render() {
    return (
      <div class={`notification has-shadow ${this.notification.type}`}>
        <p>{this.notification.message}</p>
      </div>
    );
  }
}

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-02dc42b0/notification.tsx" });